import { Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import {SessionService, ConstantsService, CompaniesEnum, AccountService, CompanyDetails} from '@app/base/core';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { Router } from '@angular/router';
import { BuilderService } from '@app/modules/builder';
import { SocoHttpService } from '@app/soco/http';
import {Subscription} from "rxjs";

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'builder-header',
  templateUrl: './builder.header.component.html',
  styleUrls: ['./builder.header.component.css']
})
export class BuilderHeaderComponent implements OnInit, OnDestroy {
  public activeLdc: CompanyDetails;
  public document: any;
  public checklist: any;
  public flag = true;
  public fileid: number;
  documentInput: any = {};
  public filesArr = [];
  public waitFlag = false;
  private activeCode$: Subscription;
  constructor(public router: Router,
    public constantsSvc: ConstantsService,
    public sessionSvc: SessionService,
    public accountService: AccountService,
    public config: SocoConfigurationService,
    public builderSvc: BuilderService,
    public renderer: Renderer2,
    public socoHttp: SocoHttpService) {
  }

@ViewChild('download', {static: false}) downloadFile: ElementRef;
  get navBrandLink() { return `/${this.sessionSvc.paramLdc.toLowerCase()}/${this.sessionSvc.paramLdc === CompaniesEnum.SC ?
     'company' : 'home'}`; }

  ngOnInit() {
    this.document = 3035424;
    this.checklist = 3032105;

    // Updated to observable to support webauth page reload which cause reset value to defaultLdc
    this.activeCode$ = this.sessionSvc.activeLdcDetails.subscribe(res => {
      this.activeLdc = res;
    });

    this.sessionSvc.builderData.subscribe(success => {
      if (success) {
        this.documentInput.Builder = success.CompanyName;
        this.documentInput.Folder = this.constantsSvc.HeaderfolderName;
      }
  });
  }

  resolveUserIdentity() {
    return this.accountService.account.user.givenName ?
    this.accountService.account.user.givenName : this.accountService.account.user.username;
  }

  navigateHome() {
    if (this.sessionSvc.sourceToContract !== this.constantsSvc.ApplicantUser)    {
    this.sessionSvc.GetBcaData(null);
    this.router.navigate([
      this.sessionSvc.paramLdc.toLowerCase(),
      'builder',
      'home'
      ]);
    } else {
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(),  'status']);
    }
  }

  downloadDoc(docType) {
    // For How to document -> Category is HOW TO DOCUMENT
    // For  Builder Checklist -> Category is BUILDER CHECKLIST
    // For Multi-family checklist -> category is MULTIFAMILY CHECKLIST
    // Please add proper category in metadata while uploading documents manually
  this.filesArr = [];
  this.documentInput.documentType = docType;
  this.waitFlag = true;
  this.passFlag();
  this.builderSvc.findFilesByMetadata(this.documentInput).subscribe(result => {
    this.waitFlag = false;
    this.passFlag();
    if (result.data.length !== 0) {
      for ( let i = 0; i < result.data.length; i++) {
          this.filesArr.push(result.data[i]);
      }
      const recentdate = new Date(Math.max.apply(null, this.filesArr.map(function(e) {
        return new Date(e.creationDate);
      })));
      const mostRecentObject = this.filesArr.filter( e => {
        const d = new Date( e.creationDate );
        return d.getTime() === recentdate.getTime();
    })[0];
      this.fileid = mostRecentObject.id;
      this.renderer.setAttribute(this.downloadFile.nativeElement, 'href', this.config.webApiBaseUrl + '/Files/Download?id=' + this.fileid);
      this.downloadFile.nativeElement.click();
    } else {
      this.waitFlag = false;
      swal(this.constantsSvc.headerDocReqSwal, this.constantsSvc.headerDocFailSwal, this.constantsSvc.errorSwal);
    }
  },
  (error) => {
    this.waitFlag = false;
    swal(this.constantsSvc.headerDocReqSwal, this.constantsSvc.headerDocFailSwal, this.constantsSvc.errorSwal);
  });
  }

  passFlag() {
    this.sessionSvc.GetwaitFlag(this.waitFlag);
  }

  ngOnDestroy() {
    this.activeCode$.unsubscribe();
  }

  downloadTrainingDoc(): void{
    const link = document.createElement('a');
    link.href = 'assets/documents/BuilderFirstTrainingDocument.pdf';
    link.download = 'Builder First Training Document.pdf';
    link.click();
  }
}
